import styled, { css } from 'styled-components';

import { HexColorBar } from '@dreryk/react-components';

export const StyledReceptionServiceColorBar = styled(HexColorBar)<{ appointmentCancelled: boolean }>`
   position: absolute;
   left: 0;
   top: 0;
   bottom: 0;
   width: 10px;

   ${(props) =>
      props.appointmentCancelled &&
      css`
         opacity: 0.2;
      `}
`;

StyledReceptionServiceColorBar.displayName = 'StyledReceptionServiceColorBar';
